<template>
	<el-dialog top="1vh" title="修改记录" width="1050px" :visible.sync="is_show_in_page">
        <el-button type="primary" style="margin-bottom:10px ;" @click="message_add">添加</el-button>
        <!-- 表格 -->
		<div class="tab_height">
			<el-table 
				size="small" 
				height="500px" 
				:data="list.data" 
				:border="true" 
				:stripe="true" 
			>
				<el-table-column label="运单编号" width="195px">
					<template slot-scope="scope">
						<div class="tab_line_item">{{scope.row.truck_tord_num}}</div>
					</template>
				</el-table-column>
				<el-table-column label="操作人信息" >
					<template slot-scope="scope">
						<div class="tab_line_item">{{scope.row.operate}}</div>
					</template>
				</el-table-column>
				<el-table-column label="操作类型">
					<template slot-scope="scope">
						<div class="tab_line_item">{{scope.row.type_text}}</div>
					</template>
				</el-table-column>
                <el-table-column label="备注">
					<template slot-scope="scope">
						<div class="tab_line_item">{{scope.row.content}}</div>
					</template>
				</el-table-column>
                <el-table-column label="操作" width="50px">
					<template slot-scope="scope">
						<el-button class="btn_left" @click="message_dele(scope.row.id)" size="mini" type="text">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>

        <!-- 添加消息提醒 -->
		<messageAdd
			:is_show="message.is_show"
			:truck_tord_num="message.truck_tord_num"
            :list_type="message.type"
			@refresh="init()"
		></messageAdd>
	</el-dialog>
</template>
<script>
import {mapState} from 'vuex'
import messageAdd from './add.vue'
	export default {
		props:{
			is_show:Number,
			truck_tord_num:String,
		},
        components:{
            messageAdd
        },
		data() {
			return {
				//页面是否显示
				is_show_in_page:false,

                list:{
                    data:[]
                },
                //消息提醒数据
				message:{
					truck_tord_num:'',
					is_show:'',
                    type:1
				},
			}
		},
		computed:{
			
		},
		watch:{
			is_show(new_data){
				if(new_data){
					this.is_show_in_page=true;
			
				    this.init();
				}
			},
		},
		methods: {
            //添加消息提醒
            message_add(item){
                this.message.truck_tord_num = this.truck_tord_num
                this.message.is_show++
            },
            //删除
            message_dele(id){
                this.$my.other.confirm({
					content:"是否确认提交删除?",
					confirm:()=>{
						this.$my.net.req({
							data:{
								mod:'truck_tord_real_time',
								ctr:'message_del',
                                id,
							},callback:(res)=>{
								this.$my.other.msg({
									str:'提交成功',
									type:'success'
								});
								this.init()
							}
						})
					}
				});
            },
			init(){
                this.$my.net.req({
                    take_over_control:1,
                	data:{
                		mod:'truck_tord_real_time',
                		ctr:'message_list',
                		truck_tord_num:this.truck_tord_num
                	},
                	callback:(data)=>{
                        if(data.code !=0){
                            this.$my.other.msg({
                                str:data.error_info,
                                type:'info'
                            });
                            this.list.data = []
                            return
                        }
                        for(let item of data.msg.list){
                            //操作类型
                            switch(item.type){
                                case '1':item.type_text="提醒消息";break;
                                case '2':item.type_text="功能消息";break;
                            }
                        }
                        this.list.data = data.msg.list
                	}
                })
                // for(let item of this.data){
                //     item.act_time_text = this.$my.other.totime(item.act_time);
                // }
                // this.list.data = this.data
			},
		}
	}
</script>
<style lang="scss" scoped>

	
</style>